import React, {useState, useContext, useEffect} from 'react';
import {  Typography,Snackbar, Grid, Button, LinearProgress } from '@mui/material';
import Paper from '@mui/material/Paper';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import UserContext from '../contexts/UserContext';
// import Dashboard from '../components/private/Dashboard'
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(3),
        width: "90%",
        maxWidth: 400,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: theme.spacing(3),
    },
    submit: {
            margin: theme.spacing(3, 0, 2),
    },
    progress: theme.progress
})); 

const Login = (props) => {

    const classes = useStyles();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    
    const user = useContext(UserContext);
    const navigate = useNavigate(); 

    // const useAuth = () => {
    
    //     user.checkToken();
    
    //     return user.isAuth;
    // }

    // const isAuth = useAuth();  

    useEffect(() => {
        if (user.isAuth) {
            navigate('/dashboard');  // Redirect to Dashboard when isAuth becomes true
        }
    }, [user.isAuth, navigate]); 

    return (
        <Paper className={classes.paper}>
            <Typography component="h1" variant="h5" align="center">
                Anmelden
            </Typography>
            <TextField
                id="loginform-email"
                label="E-Mail Adresse"
                placeholder="E-Mail"
                margin="normal"
                variant="outlined"
                required={true}
                fullWidth={true}
                autoComplete="email"
                type="email"
                autoFocus
                value={email}
                onChange={(e) => { setEmail(e.target.value); }}  
                disabled={user.loginStatus === "processing"}
            />
            <TextField
                id="loginform-password"
                label="Passwort"
                type="password"
                placeholder="Passwort" 
                margin="normal"
                variant="outlined"
                required={true}
                fullWidth={true}
                value={password}
                onChange={(e) => { setPassword(e.target.value) }}  
                disabled={user.loginStatus === "processing"}
                autoComplete="current-password"
            />
            <Button
                variant="contained"
                color="primary"
                size="large"
                className={classes.submit}
                fullWidth={true}
                type="submit"
                disabled={user.loginStatus === "processing" || email === "" || password === ""}
                onClick={() => { 
                    user.processLogin(email, password);
                }}
            >
                Login
            </Button>
     
            {user.loginStatus === "processing" ? (
                <LinearProgress color="secondary" />
            ) : (
                ""
            )}
    
            <Grid container> 
                <Grid item xs>
                    {/* <Link href="#" variant="body2">
                        Passwort vergessen?
                    </Link> */}
                </Grid>
            </Grid>
            <Snackbar open={user.loginStatus==="error"} autoHideDuration={6000} onClose={()=>{user.setLoginStatus(null)}}>
                <Alert onClose={() => { user.setLoginStatus(null) }} severity="error">
                    Die Anmeldung hat nicht geklappt, bitte versuch es nochmal.
                </Alert>
            </Snackbar>
        </Paper>
    );
    

}

export default Login;